import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/state/AppContext";
import { localized } from "@/theme/tenantTheme";
import { Button } from "@/components/ui/button";

/** The free-tier "list your business" upsell. Platform-only: removed entirely under white-label
 * (PR5), since a paying business's own page should never pitch a competitor's listing next to it.
 * Storefront S5 (gap review item 6): restyled to match the handoff's dark brand-deep card — white
 * heading "List your business in <City>", one short line, an accent "List my business" button —
 * instead of a dashed light card (every `*.dc.html` ASIDE's last block). City comes from the real
 * tenant, never hardcoded. */
export function Upsell({ business }) {
  const { t, tenant, lang } = useApp();
  if (business?.plan === "premium" && business?.logo_url) return null;
  return (
    <div
      className="space-y-3 rounded-2xl bg-[hsl(var(--brand-deep))] p-5 text-[color:var(--brand-cream)]"
      data-testid="storefront-upsell"
    >
      <p className="font-heading text-base font-bold">
        {tenant?.name ? t("storefront.upsell.title", { city: localized(lang, tenant, "name") }) : t("storefront.upsell.titleGeneric")}
      </p>
      <p className="text-xs leading-relaxed text-[color:var(--brand-cream)]/70">{t("storefront.upsell.body")}</p>
      <Button
        asChild
        className="rounded-full bg-[hsl(var(--accent))] text-[hsl(var(--accent-ink))] hover:bg-[hsl(var(--accent))]/90"
        data-testid="storefront-upsell-cta"
      >
        <Link to="/onboarding-request">{t("storefront.upsell.cta")}</Link>
      </Button>
    </div>
  );
}
